import _objectWithoutPropertiesLoose from "@babel/runtime/helpers/esm/objectWithoutPropertiesLoose";
const _excluded = ["scopes", "gates", "permissionsExtraData", "lockPermissions", "children", "onActionButtonClick", "onClick"];
import { useMemo } from 'react';
import { useAssetActions } from 'asset-actions-lib/context/AssetActionsContext';
import { LockedIcon } from 'foundations-assets';
import { checkShouldBeLocked } from '../utils/permissions';
import { Flex } from 'foundations-components/components/Flex';
import { Button } from 'foundations-components/transitional/components/Button';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
const LockedActionButton = _ref => {
  let {
      scopes,
      gates,
      permissionsExtraData,
      lockPermissions,
      children,
      onActionButtonClick,
      onClick
    } = _ref,
    restButtonProps = _objectWithoutPropertiesLoose(_ref, _excluded);
  const {
    crmObject
  } = useAssetActions();
  const shouldLockAction = useMemo(() => {
    return lockPermissions && checkShouldBeLocked({
      permissions: lockPermissions,
      scopes,
      gates,
      crmObjects: [crmObject],
      isBulkAction: false,
      permissionsExtraData
    });
  }, [lockPermissions, crmObject, gates, scopes, permissionsExtraData]);

  // Uses the consumer-provided onActionButtonClick handler if the action is
  // locked. Otherwise uses the internal onClick (which opens the provided
  // ModalOrPanel) or falls back to onActionButtonClick handler (this would
  // happen for non-standard actions where the user wants to handle
  // the action button click themselves).
  const onClickHandler = shouldLockAction ? onActionButtonClick : onClick || onActionButtonClick;
  return /*#__PURE__*/_jsx(Button, {
    active: restButtonProps.active,
    "aria-label": restButtonProps['aria-label'],
    "aria-pressed": restButtonProps['aria-pressed'],
    autoFocus: restButtonProps.autoFocus,
    block: restButtonProps.block,
    buttonRef: restButtonProps.buttonRef,
    "data-test-id": restButtonProps['data-test-id'],
    disabled: restButtonProps.disabled,
    external: restButtonProps.external,
    href: restButtonProps.href,
    iconProps: restButtonProps.iconProps,
    id: restButtonProps.id,
    rel: restButtonProps.rel,
    responsive: restButtonProps.responsive,
    role: restButtonProps.role,
    size: restButtonProps.size,
    tabIndex: restButtonProps.tabIndex,
    target: restButtonProps.target,
    truncate: restButtonProps.truncate,
    truncateStringProps: restButtonProps.truncateStringProps,
    truncateTooltip: restButtonProps.truncateTooltip,
    type: restButtonProps.type,
    use: restButtonProps.use,
    onClick: onClickHandler,
    children: /*#__PURE__*/_jsxs(Flex, {
      alignItems: "center",
      columnGap: "100",
      children: [children, shouldLockAction && /*#__PURE__*/_jsx(LockedIcon, {})]
    })
  });
};
export default LockedActionButton;